type PerfSample = {
  name: string
  value: number
  ts: number
  detail?: Record<string, unknown>
}

type NavKind = 'chat-open' | 'group-open' | 'topic-open'

const PERF_STORAGE_KEY = 'agentchat:perf-samples:v1'
const MAX_SAMPLES = 200
const _navStarts = new Map<string, { start: number; detail?: Record<string, unknown> }>()

function canUsePerf(): boolean {
  return typeof window !== 'undefined' && typeof window.performance !== 'undefined'
}

function navKey(kind: NavKind, target: string): string {
  return `${kind}:${target}`
}

export function recordPerfSample(
  name: string,
  value: number,
  detail?: Record<string, unknown>,
): void {
  if (typeof window === 'undefined') return
  const sample: PerfSample = {
    name,
    value: Math.round(value),
    ts: Date.now(),
    detail,
  }
  try {
    const previous = JSON.parse(window.localStorage.getItem(PERF_STORAGE_KEY) || '[]') as PerfSample[]
    const next = [...previous, sample].slice(-MAX_SAMPLES)
    window.localStorage.setItem(PERF_STORAGE_KEY, JSON.stringify(next))
  } catch {
    // Telemetry must never affect navigation.
  }
}

export function startNavTiming(
  kind: NavKind,
  target: string,
  detail?: Record<string, unknown>,
): void {
  if (!canUsePerf()) return
  const key = navKey(kind, target)
  const existing = _navStarts.get(key)
  if (existing && window.performance.now() - existing.start < 5_000) return
  _navStarts.set(key, {
    start: window.performance.now(),
    detail,
  })
}

export function finishNavTiming(
  kind: NavKind,
  target: string,
  detail?: Record<string, unknown>,
): number | null {
  if (!canUsePerf()) return null
  const key = navKey(kind, target)
  const current = _navStarts.get(key)
  if (!current) return null
  _navStarts.delete(key)
  const duration = window.performance.now() - current.start
  recordPerfSample(`nav:${kind}`, duration, {
    ...(current.detail ?? {}),
    ...(detail ?? {}),
    target,
  })
  return duration
}
